import React from 'react';

import IconWithText from 'components/Widgets/IconWithText';

export default function FinishReturnToWork() {
  return (
    <>
      <h1>Congratulations!</h1>
      <p className="mt-3">
        You have completed the first step towards a successful return to work.
      </p>

      <IconWithText
        iconClassName="big-icon onboarding-cpa-download-icon-1 bg-secondary"
        wrapperClassName="mb-3 mt-5"
      >
        <h6>
          Review your Health and Performance Assessment results to understand
          your readiness for workplace reintegration.
        </h6>
      </IconWithText>

      <IconWithText
        iconClassName="big-icon onboarding-cpa-download-icon-2 bg-secondary"
        wrapperClassName="mb-3"
      >
        <h6>Share insights with your return-to-work coordinator to develop an effective transition plan.</h6>
      </IconWithText>

      <IconWithText
        iconClassName="big-icon onboarding-cpa-download-icon-3 bg-secondary"
        wrapperClassName="mb-3"
      >
        <h6>
          Take the next step now: Click &apos;Assessment Debrief&apos; to get personalized
          guidance from your AI coach on your return-to-work journey.
        </h6>
      </IconWithText>
    </>
  );
}
